import { createContext, useContext } from "react";

export type ConnectionState =
  | "Connecting"
  | "Catching up"
  | "Connected"
  | "Updates delayed"
  | "Offline"
  | "Sign in to reconnect"
  | "Chat access unavailable"
  | "Local UI fixture";

export interface RealtimeContextValue {
  connection: ConnectionState;
  chatId: string | null;
  typingMemberIds: string[];
  sendTyping: (active: boolean) => void;
}

export const RealtimeContext = createContext<RealtimeContextValue>({
  connection: "Local UI fixture",
  chatId: null,
  typingMemberIds: [],
  sendTyping: () => undefined,
});
export const useRealtimeStatus = () => useContext(RealtimeContext);
